import { SERVICES } from "./services";
import { PROJECTS } from "./work";

/** Public, indexable URLs — used for the sitemap page and sitemap.xml export. */
export const SITEMAP_GROUPS: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "Studio",
    links: [
      { label: "Home", href: "/" },
      { label: "Services", href: "/services" },
      { label: "Work", href: "/work" },
      { label: "Live Demo", href: "/demo" },
      { label: "Pricing", href: "/pricing" },
      { label: "Process", href: "/process" },
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
    ],
  },
  { title: "Services", links: SERVICES.map((s) => ({ label: s.name, href: `/services/${s.slug}` })) },
  { title: "Work", links: PROJECTS.map((p) => ({ label: p.title, href: `/work/${p.slug}` })) },
  {
    title: "Resources",
    links: [
      { label: "Blog", href: "/resources" },
      { label: "FAQ", href: "/resources/faq" },
      { label: "Website Checklist", href: "/resources/website-checklist" },
    ],
  },
  {
    title: "Clients & Legal",
    links: [
      { label: "Client Login", href: "/client-login" },
      { label: "Register", href: "/register" },
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Cancellation Policy", href: "/cancellation-policy" },
    ],
  },
];
